module.exports = __webpack_public_path__ + "static/img/36a12b4f.png";